import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from 'react-redux';
 
 
 
 const TreeNode = memo(({ node, level = 0 }) => {
        const [visible, setVisible] = useState(false);
      
        useEffect(() => {
            const timer = setTimeout(() => setVisible(true), level * 400);
            return () => clearTimeout(timer);
          }, [level]);
      
        return (
          <div className="tree-node">
            <div>
              <div className={`node ${visible ? "visible" : ""}`}>{node.name}</div>
      
              {node.children && node.children.length > 0 && node.children.some(child => child?.name) && (
                <div className="children">
                  <div className={`line ${visible ? "visible" : ""}`}></div>
                  <div className="child-nodes">
                    {node.children.map((child, index) => (
                      <TreeNode key={index} node={child} level={level + 1} />
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      });
export default connect()(TreeNode)